module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Collection of Sand: Essays")]), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "EB04MainHead",
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("The Author’s Presentation of the Volume")]), _vm._v(" "), _c('p', {
    staticClass: "EB02BodyTextFullOut",
    attrs: {
      "id": "col0000085"
    }
  }, [_vm._v("From Paris Italo Calvino periodically sends\n\t\t\tan article on an unusual exhibition to the newspaper he collaborates with ["), _c('em', [_vm._v("la\n\t\t\t\tRepubblica")]), _vm._v("]."), _c('sup', {
    staticClass: "EBsup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authorspresentation_fn#fn1",
      "id": "fn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" This allows him to tell a\n\t\t\tstory through a series of objects: ancient maps or globes, wax manikins, clay tablets\n\t\t\twith cuneiform writing, the popular press, traces of tribal cultures and so on. Some\n\t\t\ttraits of the author’s physiognomy come through in these ‘occasional’\n\t\t\tpieces: an omnivorous, encyclopedic curiosity, and a desire to distance himself\n\t\t\tdiscreetly from any form of specialism; respect for journalism as a way of providing\n\t\t\timpersonal information and the pleasure of relegating his own opinions to marginal\n\t\t\tobservations or hiding them between the lines; an obsessive meticulousness and\n\t\t\tdispassionate contemplation when it comes to the truth of the world. Along with ten of\n\t\t\tthese accounts of walks through the rooms of Parisian galleries, "), _c('em', [_vm._v("Collection of\n\t\t\t\tSand")]), _vm._v(" includes other essays on ‘things observed’, or essays which,\n\t\t\teven though they start out from the reading of a book, have as their subject the visible\n\t\t\tor the very act of seeing (including what the imagination sees). The volume is rounded\n\t\t\toff by three sections containing reflections penned during his travels to other\n\t\t\tcivilizations: Iran, Mexico, Japan. These pieces start from ‘things\n\t\t\tobserved’ and open out to offer glimpses of other dimensions of the mind.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b8292f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorspresentation.vue
// module id = 66
// module chunks = 0